import Cookies from "js-cookie";
import { setUserData } from "../state/reducers/userSlice";
import store from "../state/store";
import { setAdminDashboardTab, setAdminDirectoryTab } from "../state/reducers/applicationSlice";

const cookieOptions = {
  domain: process.env.REACT_APP_DOMAIN,
  secure: !!process.env.REACT_APP_SECURE,
  sameSite: process.env.REACT_APP_SAMESITE,
  path: "/",
};
const resetBrowserStorage = () => {
  localStorage?.removeItem("userData");
  localStorage?.removeItem("adminDashboardTab");
  localStorage?.removeItem("adminDirectoryTab");
  store.dispatch(setUserData(null));
  store.dispatch(setAdminDashboardTab(0));
  store.dispatch(setAdminDirectoryTab(1));
};

export const setAuthTokenCookie = (token) => {
  Cookies.set("auth-token", token, cookieOptions);
};

export const getAuthTokenCookie = () => {
  return Cookies.get("auth-token");
};

export const removeAuthTokenCookie = () => {
  Cookies.remove("auth-token", { domain: cookieOptions.domain, path: cookieOptions.path });
  resetBrowserStorage();
};

export const setLoginTokenCookie = (token) => {
  Cookies.set("login-token", token, cookieOptions);
};

export const getLoginTokenCookie = () => {
  return Cookies.get("login-token");
};

export const removeLoginTokenCookie = () => {
  Cookies.remove("login-token", { domain: cookieOptions.domain, path: cookieOptions.path });
};

export const setAdminAuthTokenCookie = (token) => {
  Cookies.set("auth-token", token);
};

export const removeAdminAuthTokenCookie = () => {
  Cookies.remove("auth-token");
  resetBrowserStorage();
};

export const setAdminLoginTokenCookie = (token) => {
  Cookies.set("login-token", token);
};

export const removeAdminLoginTokenCookie = () => {
  Cookies.remove("login-token");
};
